import React from 'react'
import PropTypes from 'prop-types'
import CardVariant from './variants/CardVariant'
import { sharedPropTypes } from './propTypes'
import ListItemVariant from './variants/ListItemVariant'

function RSSFeedItem ({
  variant,
  ...props
}) {
  if (variant === 'card') {
    return <CardVariant {...props} />
  }

  if (variant === 'list-item') {
    return <ListItemVariant {...props} />
  }

  return null
}

RSSFeedItem.propTypes = {
  ...sharedPropTypes,
  imagePosition: PropTypes.oneOf(['top', 'left', 'right']),
  className: PropTypes.string,
  style: PropTypes.object
}

RSSFeedItem.defaultProps = {
  item: undefined,
  variant: 'card',
  title: { accessor: 'title' },
  body: { accessor: 'content' },
  image: { accessor: 'image' },
  footer: [
    { accessor: 'pubDate', className: 'text-neutral-500' },
    { accessor: 'author', prependText: 'Author: ' },
    { accessor: 'link', label: 'Read more', className: 'flex flex-1 justify-end' }
  ],
  contentType: 'html'
}

export default RSSFeedItem
